var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronRight20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.47 4.22c-.3.29-.3.76 0 1.06L12.19 10l-4.72 4.72a.75.75 0 1 0 1.06 1.06l5.25-5.25c.29-.3.29-.77 0-1.06L8.53 4.22a.75.75 0 0 0-1.06 0Z",
  clipRule: "evenodd"
})));
export { SvgChevronRight20 as ReactComponent };